// extracted by mini-css-extract-plugin
export default {"mainContainer":"Record_mainContainer__97K22"};